
/**
 * Date()).format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 (new
 * Date()).format("yyyy-MM-dd E HH:mm:ss") ==> 2009-03-10 二 20:09:04 (new
 * Date()).format("yyyy-MM-dd EE hh:mm:ss") ==> 2009-03-10 周二 08:09:04 (new
 * Date()).format("yyyy-MM-dd EEE hh:mm:ss") ==> 2009-03-10 星期二 08:09:04 (new
 * Date()).format("yyyy-M-d h:m:s.S") ==> 2006-7-2 8:9:4.18
 */
function dateFormat (date, format = 'yyyy/MM/dd') {
    if (!date) {
        return '-'
    }
    try {
        date = date.replace(/t/gi, ' ').replace(/-/g, '/').replace(/\.000\+0800/g, '')
    } catch (e) {

    }
    if (typeof date === 'string') {
        if (!date.match(/\//g)) {
            date = `${date}/01/01`
        } else if (date.match(/\//g).length == 1) {
            date = `${date}/01`
        }
    }
    let d = new Date(date)

    let o = {
        'M+': d.getMonth() + 1,
        // 月份
        'd+': d.getDate(),
        // 日
        'h+': d.getHours() % 12 == 0 ? 12 : d.getHours() % 12,
        // 小时
        'H+': d.getHours(),
        // 小时
        'm+': d.getMinutes(),
        // 分
        's+': d.getSeconds(),
        // 秒
        'q+': Math.floor((d.getMonth() + 3) / 3),
        // 季度
        'S': d.getMilliseconds()
            // 毫秒
    }
    let week = {
        '0': '日',
        '1': '一',
        '2': '二',
        '3': '三',
        '4': '四',
        '5': '五',
        '6': '六'
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (d.getFullYear() + '')
            .substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(format)) {
        format = format.replace(
            RegExp.$1,
            ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '星期' :
                    '周') :
                '') + week[d.getDay() + ''])
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) :
                (('00' + o[k]).substr(('' + o[k]).length)))
        }
    }
    return format
}



module.exports = {
    dateFormat
}